import React from "react";
import './download-publish-modal.scss'
import {DownloadPanel} from "./components/download-panel";
import PropTypes from 'prop-types';

/**
 * @author Ahsan Ejaz <ahsan@250mils.com>
 */
const DownloadPublishModal = ({productsData, formats, defaultProductId}) => {
    return (
        <div className={'download-publish-content'}>
            <DownloadPanel productsData={productsData} formats={formats} defaultProductId={defaultProductId}/>
        </div>
    )
}

DownloadPublishModal.protoTypes = {
    /**
     * List of applicable download products
     */
    productsData: PropTypes.arrayOf(PropTypes.object).isRequired,
    /**
     * List of download formats for the design
     */
    formats: PropTypes.array.isRequired
}


export default DownloadPublishModal
